import { useCallback } from 'react'
import useLocalStorageState from 'use-local-storage-state'
import { SUPER_ADMIN_COMPANY_KEY } from '@/lib/auth-utils'

/**
 * Hook for managing super admin selected company ID in localStorage
 * This provides type-safe, SSR-compatible storage with automatic serialization
 */
export function useSuperAdminCompany() {
  const [selectedCompanyId, setSelectedCompanyId] = useLocalStorageState<
    string | null
  >(SUPER_ADMIN_COMPANY_KEY, {
    defaultValue: null,
  })

  const clearSelectedCompany = useCallback(() => {
    setSelectedCompanyId(null)
  }, [setSelectedCompanyId])

  return {
    selectedCompanyId,
    setSelectedCompanyId,
    clearSelectedCompany,
  }
}
